/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconSoFileOpenCreate = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-so-file-open-create',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { d: "M5.418 21.249c-.527 0-.979-.189-1.354-.566a1.857 1.857 0 0 1-.564-1.36V3.926c0-.53.188-.983.564-1.36A1.844 1.844 0 0 1 5.418 2h7.674l5.756 5.775v6.591h-1.919V8.738h-4.603V3.6h-7.06v16h8.133v1.649H5.42Z" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.187 21.165c.05.51.505.881 1.015.83l4.563-.454.068-4.72a.928.928 0 0 0-1.856-.027l-.022 1.532-.022 1.533-.953.095-1.962.195a.928.928 0 0 0-.831 1.015Z" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.98 19.954 9.69 12.586a.927.927 0 1 1 1.233-1.386l8.457 7.515c1.015.901-.482 2.053-1.399 1.239Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconSoFileOpenCreate.displayName = 'IconSoFileOpenCreate';
export default IconSoFileOpenCreate;
